import { render, staticRenderFns } from "./AddNewRoleModal.vue?vue&type=template&id=6ad0e2b6&scoped=true&"
import script from "./AddNewRoleModal.vue?vue&type=script&lang=js&"
export * from "./AddNewRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNewRoleModal.vue?vue&type=style&index=0&id=6ad0e2b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad0e2b6",
  null
  
)

export default component.exports